/* "Added to cart" confirmation toast.

   DELIBERATELY DECOUPLED. It listens for the `cart:refresh` event that
   dm-card.js and dm-product.js already dispatch on a successful add, so
   neither of those files needed changing and there is no second copy of the
   add-to-cart logic to keep in sync. Anything else that ever adds to the cart
   gets the toast for free just by dispatching the same event.

   The product name is captured on the way in: the click that starts an add is
   noted (nearest card title, or the buy box's h1), and read back when the add
   resolves. Reading it from /cart.js instead would be wrong - that endpoint
   returns line items in the order they were FIRST added, so re-adding an item
   already in the cart leaves it in place and "the last one" is not knowable.

   Styles are injected once, on first use. This component cannot exist without
   JavaScript, so shipping its CSS in a render-blocking stylesheet that most
   page views never need would be pure cost. */
(function () {
  'use strict';

  var CSS =
    '.dm-toast{position:fixed;z-index:120;left:var(--gut,16px);right:var(--gut,16px);bottom:16px;' +
    'display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;' +
    'background:var(--white,#fff);border:1px solid var(--hairline,#F2D8E4);' +
    'box-shadow:0 12px 34px rgba(57,20,37,.16);font-family:var(--font-body,system-ui);' +
    'transform:translateY(140%);opacity:0;transition:transform .28s cubic-bezier(.22,1,.36,1),opacity .28s ease}' +
    '.dm-toast.is-on{transform:translateY(0);opacity:1}' +
    '.dm-toast__tick{flex:none;width:26px;height:26px;border-radius:50%;display:grid;place-items:center;' +
    'background:var(--pink-primary,#FF3B8D);color:#fff;font-size:14px;line-height:1}' +
    '.dm-toast__body{flex:1;min-width:0}' +
    '.dm-toast__title{display:block;font-size:13px;font-weight:600;color:var(--black,#111);line-height:1.3}' +
    '.dm-toast__name{display:block;margin-top:2px;font-size:12px;color:var(--ink-60,#5A5A5F);line-height:1.4;' +
    'overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}' +
    '.dm-toast__acts{display:flex;gap:8px;flex:none}' +
    '.dm-toast__acts a{display:inline-flex;align-items:center;justify-content:center;min-height:38px;padding:0 12px;' +
    'border-radius:8px;font-size:13px;font-weight:600;text-decoration:none;white-space:nowrap}' +
    '.dm-toast__cart{color:var(--black,#111);border:1px solid var(--black,#111)}' +
    '.dm-toast__co{color:#fff;background:var(--pink-primary,#FF3B8D)}' +
    '.dm-toast__x{flex:none;width:32px;height:32px;padding:0;border:0;background:none;cursor:pointer;' +
    'color:var(--ink-60,#5A5A5F);font-size:18px;line-height:1}' +
    'body:has(.dm-stick.is-on) .dm-toast{bottom:80px}' +
    '@media(min-width:720px){.dm-toast{left:auto;right:24px;bottom:24px;max-width:440px}' +
    'body:has(.dm-stick.is-on) .dm-toast{bottom:88px}}' +
    '@media(prefers-reduced-motion:reduce){.dm-toast{transition:none}}';

  var lastName = '';
  var el = null;
  var hideTimer = null;

  /* Note the product name as the add STARTS, so it is still knowable when the
     request resolves. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-add],[data-atc],[data-stick-atc]');
    if (!trigger) return;
    var card = trigger.closest('[data-card]');
    var titleEl = card
      ? card.querySelector('.dm-card__title')
      : document.querySelector('.dm-buy h1');
    lastName = titleEl ? titleEl.textContent.trim() : '';
  }, true);

  function build() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    el = document.createElement('div');
    el.className = 'dm-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="dm-toast__tick" aria-hidden="true">✓</span>' +
      '<span class="dm-toast__body">' +
        '<span class="dm-toast__title">Added to cart</span>' +
        '<span class="dm-toast__name"></span>' +
      '</span>' +
      '<span class="dm-toast__acts">' +
        '<a class="dm-toast__cart" href="/cart">View cart</a>' +
        '<a class="dm-toast__co" href="/checkout">Checkout</a>' +
      '</span>' +
      '<button class="dm-toast__x" type="button" aria-label="Dismiss">×</button>';
    el.querySelector('.dm-toast__x').addEventListener('click', hide);
    /* keep it up while the pointer is on it, so it cannot vanish mid-click */
    el.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', arm);
    document.body.appendChild(el);
  }

  function hide() {
    clearTimeout(hideTimer);
    if (el) el.classList.remove('is-on');
  }

  function arm() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 5000);
  }

  function show() {
    if (!el) build();
    var name = el.querySelector('.dm-toast__name');
    name.textContent = lastName;
    name.hidden = !lastName;
    /* restart the entry transition even if it is already showing */
    el.classList.remove('is-on');
    void el.offsetWidth;
    el.classList.add('is-on');
    arm();
  }

  document.addEventListener('cart:refresh', show);
})();
